export default __webpack_public_path__ + "static/ecommerce-5b7d0807d431e5dbf0a03a90f4434c2a.jpg";